import { render, staticRenderFns } from "./Supervisor.vue?vue&type=template&id=62334712&scoped=true"
import script from "./Supervisor.vue?vue&type=script&lang=js"
export * from "./Supervisor.vue?vue&type=script&lang=js"
import style0 from "./Supervisor.vue?vue&type=style&index=0&id=62334712&prod&lang=css"
import style1 from "./Supervisor.vue?vue&type=style&index=1&id=62334712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62334712",
  null
  
)

export default component.exports